import AssetsSection from '@/views/assets/AssetsSection.vue';
import Assets from '@/views/assets/Assets.vue';
import Asset from '@/views/assets/Asset.vue';
import AssetDetails from '@/views/assets/tabs/AssetDetails.vue';
import AssetDelete from '@/views/assets/tabs/AssetDelete.vue';
import AssetEdit from '@/views/assets/tabs/AssetEdit.vue';
import AssetProfile from '@/views/assets/tabs/AssetProfile.vue';
import AssetSecurityInsights from '@/views/assets/tabs/AssetSecurityInsights.vue';
import Alerts from '@/views/alerts/Alerts.vue';
import Logs from '@/views/logs/Logs.vue';
import AssetDashboard from '@/views/assets/tabs/AssetDashboard.vue';

export default [
  {
    path: '/assets',
    component: AssetsSection,
    meta: {
      breadcrumb: {
        linkName: 'assets.index',
        linkText: 'Assets',
      },
    },
    children: [
      {
        path: '',
        component: Assets,
        name: 'assets.index',
      },
      {
        path: ':id',
        component: Asset,
        meta: {
          breadcrumb: {
            linkName: 'assets.index.detail',
            linkText: 'Asset Info',
          },
        },
        children: [
          {
            path: '',
            name: 'assets.index.dashboard',
            component: AssetDashboard,
          },
          {
            path: 'details',
            name: 'assets.index.detail',
            component: AssetDetails,
          },
          {
            path: 'insights',
            name: 'assets.index.detail.insights',
            component: AssetSecurityInsights,
          },
          {
            path: 'profile',
            name: 'assets.index.detail.profile',
            component: AssetProfile,
          },
          {
            path: 'delete',
            name: 'assets.index.detail.delete',
            component: AssetDelete,
            props: true,
          },
          {
            path: 'edit',
            name: 'assets.index.detail.edit',
            component: AssetEdit,
            props: true,
          },
          {
            path: 'alerts',
            name: 'assets.index.detail.alerts',
            component: Alerts,
            props: true,
          },
          {
            path: 'logs',
            name: 'assets.index.detail.logs',
            component: Logs,
            props: true,
          },
        ],
      },
    ],
  },
];
